import { render } from "./DayListGroup.vue?vue&type=template&id=2201ca21"
import script from "./DayListGroup.vue?vue&type=script&lang=js"
export * from "./DayListGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__